import React from "react";

const Help=()=>{
    return <div className="pages">
        <h3>This is Help Page......</h3>
    </div>
}
export default Help;